import { lightTheme } from '@/customTheme'
import { PaddingSide } from '@/services/batchEdit/positionFit'

/**
 * All four sides are the same shape — a frame with a bar hugging the left
 * edge — rotated around center; `side` picks the rotation instead of
 * duplicating the geometry per side (Figma 12056:21347).
 */
const ROTATION_DEG: Record<PaddingSide, number> = {
  left: 0,
  top: 90,
  right: 180,
  bottom: -90,
}

interface PaddingSideIconProps {
  side: PaddingSide
  size?: number
  color?: string
}

function PaddingSideIcon({ side, size = 24, color = lightTheme.colors.blackGray }: PaddingSideIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g transform={`rotate(${ROTATION_DEG[side]} 12 12)`}>
        <rect x="2" y="2" width="20" height="20" rx="2" stroke={color} strokeWidth="2" />
        <rect x="6" y="6" width="2" height="12" rx="1" fill={color} />
      </g>
    </svg>
  )
}

export default PaddingSideIcon
